import { Breadcrumb, Button, Steps } from "antd";
import CWLayout from "../cwLayout";
import "./cwFinal.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OprationResult from "../../../auxiliary/opration/opration";
import { convertToJalaliWithoutTime } from "../../../../tools/tools";
const CWFinal = () => {
  const [t] = useTranslation("global");
  const nav = useNavigate();
  const formData = useSelector((state) => state?.from?.changeownership);
  const dispatch = useDispatch();
  const location = useLocation();
  return (
    <CWLayout>
      <div className="holder-top-of-page-content">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
          />
          <div className="title-page">
            <h3>{t("changeOwnerShip.ownership.title")}</h3>
            <p></p>
          </div>
        </div>
      </div>
      <div className="g-layout-content">
        <Content className="g-layout-main da-container">
          <div className="g-format-page">
            <div className="g-body-format-page">
              <div className="g-format-steps">
                <div className="holder-step">
                  <Steps
                    size="small"
                    className="step-wizard"
                    current={4}
                    items={[
                      {
                        title: "اطلاعات فروشنده",
                      },
                      {
                        title: "اطلاعات خریدار",
                      },
                      {
                        title: "آپلود مدرک شناسایی",
                      },
                      {
                        title: "پیش فاکتور",
                      },
                      {
                        title: "سند",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="cw-prefactor">
                <OprationResult
                  isSucess={true}
                  list={[
                    {
                      label: "تاریخ و ساعت",
                      value: (
                        <>
                          {/* <span dir="ltr">{convertToJalaliWithoutTime(location?.state?.swChange?.Date)}</span> */}
                          <span dir="ltr">{convertToJalaliWithoutTime(new Date().toISOString())}</span>
                        </>
                      ),
                    },
                    {
                      label: "نوع سرویس",
                      value: location?.state?.serviceType,
                    },
                    {
                      label: "شماره سیم کارت",
                      value: location?.state?.msisdn,
                    },
                    {
                      label: "شماره کیت جدید",
                      value: location?.state?.iccid,
                    },
                    {
                      label: "کد پیگیری",
                      value: location?.state?.strFollwUpCode,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="g-footer-format-page">
              <div className="holder-button">
                <Button
                  className="btn-normal btn-print"
                  onClick={() => {
                    window.print();
                  }}
                  type="default"
                  icon={<i className="icon-print"></i>}
                >
                  چاپ رسید
                </Button>
              </div>
            </div>
          </div>
        </Content>
      </div>
    </CWLayout>
  );
};

export default CWFinal;
